import {
    DetailedSolution,
    MeasureImpact,
    REGULATION_IMPACT_CLAZZ_VALUE,
    REROUTING_IMPACT_CLAZZ_VALUE,
    Solution,
    SolutionType,
} from 'app/model/SOL49';
import { ScenarioTvMatchingKind } from 'app/model/CORE';
import Utils from 'app/common/util/Utils';

export class SolutionUtils {
    static isInitialSolution = (s: Solution) => s.type === SolutionType.INITIAL;

    static isCustomSolution = (s: Solution) => s.type === SolutionType.CUSTOM;

    static compare = (s1: DetailedSolution, s2: DetailedSolution) => {
        const scenarioTvMatchingKindKeys = Object.keys(ScenarioTvMatchingKind);

        // Ensure that highest "applicability" for a solution according to its ScenarioTvMatchingKind are displayed first
        const mk1 = s1.tvMatchingKind
            ? scenarioTvMatchingKindKeys.length -
              scenarioTvMatchingKindKeys.indexOf(ScenarioTvMatchingKind[s1.tvMatchingKind])
            : -1;
        const mk2 = s2.tvMatchingKind
            ? scenarioTvMatchingKindKeys.length -
              scenarioTvMatchingKindKeys.indexOf(ScenarioTvMatchingKind[s2.tvMatchingKind])
            : -1;

        return mk1 - mk2;
    };

    static getInitialSolution = (solutions: DetailedSolution[]): DetailedSolution =>
        solutions.find(s => SolutionUtils.isInitialSolution(s));

    static getImpactedFMPs = (solution: DetailedSolution): string[] => {
        return Utils.removeDuplicates(
            Object.values(solution.solutionImpact.measureImpacts)
                .filter(SolutionUtils.isInitialMeasureImpact)
                .map(impact => impact.fmpUnit),
        );
    };

    // MeasureImpact object contains the "direct" measure impacts (RegulationImpact and ReroutingImpact),
    // and also contains the other impacted measures (NiaMeasureImpact)
    // This method returns the initial ones only
    static isInitialMeasureImpact = (measureImpact: MeasureImpact): boolean => {
        return (
            measureImpact.clazz === REGULATION_IMPACT_CLAZZ_VALUE ||
            measureImpact.clazz === REROUTING_IMPACT_CLAZZ_VALUE
        );
    };
}
